
import * as React from "react";
import Posts from '../components/Posts/PostsSel'

export class ComponentSel extends React.Component {
  render() {
    return (
      <div style={{margin:10}}>
        <Posts />
      </div>
      
    );
  };
};